module.exports = __webpack_public_path__ + "static/img/ninja-logo-small.008756d3.png";